import { render, staticRenderFns } from "./UdajeOFirme.vue?vue&type=template&id=4a54d975&"
import script from "./UdajeOFirme.vue?vue&type=script&lang=ts&"
export * from "./UdajeOFirme.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports